const PERMISSION_ERROR_MESSAGES = {
  USER_ROLES_PERMISSION_REQUIRED:
    "You can view this profile, but you need Manage user roles permission to change roles or permissions. Ask an owner or administrator to update your access.",
  REWARDS_PROGRAM_PERMISSION_REQUIRED:
    "You need View rewards program permission to open the Rewards Program page. Ask an owner or administrator to update your access.",
  LAST_OWNER_REQUIRED:
    "At least one active owner must remain on the salon account.",
  USER_NOT_IN_SALON:
    "This user is not currently linked to this salon.",
  PrimaryOwnerMembershipCannotBeModified:
    "The primary owner account is protected and cannot be changed here.",
};

function normalizeDetail(detail) {
  return String(detail || "").trim();
}

export function formatPermissionError(err, fallback) {
  const rawDetail =
    typeof err === "string"
      ? err
      : err?.response?.data?.detail || err?.detail || err?.message || "";
  const detail = normalizeDetail(rawDetail);

  if (!detail) {
    return fallback;
  }

  if (PERMISSION_ERROR_MESSAGES[detail]) {
    return PERMISSION_ERROR_MESSAGES[detail];
  }

  if (detail === "Primary owner membership cannot be modified") {
    return PERMISSION_ERROR_MESSAGES.PrimaryOwnerMembershipCannotBeModified;
  }

  if (/^[A-Z0-9_]+$/.test(detail)) {
    return fallback;
  }

  return detail;
}
